import { gql } from "@apollo/client";

export const GET_ANSWERS = gql`
  query getAnswers {
    answer {
      answer_id
      answer
      option_id
      question_id
      user_id
      created_at
      option {
        option_id
        order
        question_id
        text
      }
      question {
        question_id
        title
        type
        body
        order
      }
      user {
        user_id
        name
        email
        picture_url
      }
    }
  }
`;

export const GET_ANSWER_BY_ID = gql`
  query getAnswerById($answerId: uuid!) {
    answer_by_pk(answer_id: $answerId) {
      answer_id
      answer
      option_id
      question_id
      user_id
      created_at
      option {
        option_id
        order
        question_id
        text
      }
      question {
        question_id
        title
        type
        body
        order
      }
      user {
        user_id
        name
        email
        picture_url
      }
    }
  }
`;

export const GET_ANSWERS_BY_QUESTION_ID = gql`
  query getAnswersByQuestionId($questionId: uuid!) {
    answer(where: { question_id: { _eq: $questionId } }) {
      answer_id
      answer
      option_id
      question_id
      user_id
      created_at
      option {
        option_id
        order
        question_id
        text
      }
      question {
        question_id
        title
        type
        body
        order
      }
      user {
        user_id
        name
        email
        picture_url
      }
    }
  }
`;

export const GET_ANSWERS_BY_USER_AND_QUESTION_IDS = gql`
  query getAnswersByUserAndQuestionIds($userId: uuid!, $questionIds: [uuid!]!) {
    answer(where: { user_id: { _eq: $userId }, question_id: { _in: $questionIds } }) {
      answer_id
      question_id
      user_id
      created_at
    }
  }
`;
